<template>
  <v-form class="d-flex justify-center flex-column">
    <v-card-text class="d-flex flex-column align-center">
      <div class="text-h5 font-weight-bold primary--text text--darken-1 text-center">{{ $t('message.welcome', { userName: currentUser ? currentUser.full_name : '' }) }}</div>
    </v-card-text>

    <v-card-text class="d-flex flex-column align-center">
      <p class="text-center">{{ $t('message.signUpAsReferrer') }}</p>
      <p class="primary--text text--lighten-1 text-center">{{ currentUser ? currentUser.referred_by_fname : '' }}</p>
    </v-card-text>

    <v-card-text class="d-flex flex-column align-center mb-5">
      <p class="primary--text text--darken-1 font-weight-bold text-center">{{ $t('message.continueWithApp') }}</p>
      <div class="primary--text text--darken-1 text-center text-decoration-underline" @click="$emit('next-step')">{{ $t('message.continueWithWeb') }}</div>
    </v-card-text>

    <v-row align="center" justify="center">
      <a href="https://play.google.com/store/apps/details?id=com.oliving.app" target="_blank" class="d-flex justify-content-center ma-2">
        <img class="app-store-badge" src="@/assets/google-store.png" />
      </a>
      <a href="https://apps.apple.com/my/app/oly/id1572981807" target="_blank" class="d-flex justify-content-center ma-2">
        <img class="app-store-badge" src="@/assets/app-store.png" />
      </a>
      <a href="https://urldra.cloud.huawei.com/dbR4hINcpG" target="_blank" class="d-flex justify-content-center ma-2">
        <img class="app-store-badge" src="@/assets/huawei.png" />
      </a>
    </v-row>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('auth', ['currentUser'])
  }
}
</script>

<style lang="scss" scoped>
.app-store-badge {
  max-width: 140px;
}
</style>
